import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../../Context/UserContextProvider';

import HomeModal from '../HomeModal/HomeModal';

// styles
import styles from "./AddEstateBanner.module.css"

// img
import formImg from "../../../assets/img/HomePage/sample.png"
import icon1 from "../../../assets/img/HomePage/Rectangle 36 (1).svg"
import icon2 from "../../../assets/img/HomePage/Rectangle 37 (1).svg"

const AddEstateBanner = ({ bannerDataOne }) => {
    const { simpleUser } = useContext(UserContext);
    const [showModal, setShowModal] = React.useState(false)
    return (
        <>
            <HomeModal
                show={showModal}
                onHide={() => setShowModal(false)}
            />

            <section className="py-3 mb-5 mt-2">
                <div className="container-fluid">
                    <div
                        className="w-100 d-flex justify-content-center flex-wrap align-items-center mt-3 me-3"
                        dir="rtl"
                    >
                        <div className={`position-relative d-flex flex-md-row flex-column align-items-center justify-content-md-start justify-content-center ${styles.container}`}>
                            <div className={styles.images_container}>
                                <img src={formImg} alt="آگهی شما" />
                                <div className={styles.images_container_rectangle}>
                                    <img src={icon2} alt="پس زمینه آگهی شما" />
                                    <img src={icon1} alt="پس زمینه آگهی شما" />
                                </div>
                            </div>
                            <div className={`d-flex flex-column align-items-start justify-content-center me-4 ms-5 ${styles.text_container}`}>
                                <h2 className={`text-end my-2 ${styles.title}`}>
                                    {bannerDataOne?.title}
                                </h2>
                                <p className={`my-2 ${styles.description}`}>
                                    {bannerDataOne?.content}
                                </p>
                            </div>
                            <div className={styles.button_container}>
                                {simpleUser?.roles == ""
                                    ?
                                    <Link to="/user-add-new-file" className={`d-flex align-items-center justify-content-center ${styles.btn}`} >
                                        درج آگهی
                                    </Link>
                                    :
                                    <button onClick={() => setShowModal(true)} className={`d-flex align-items-center justify-content-center pointer ${styles.btn}`}>
                                        درج آگهی
                                    </button>
                                }
                                {/* <button className={styles.btn}>درج آگهی</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default AddEstateBanner;